import React, { useState } from "react";
import { Card, CardBody } from "reactstrap";
import CardHeader from "../Layout/CardHeader";
import SuperInsightsModal from "../Ia/SuperInsightsModal";
import Meta from '../Layout/Meta';

const TrendChartMulti = ({ item }) => {
  const safeItem = item || {};

  let {
    Sigla = "",
    Descricao_Dashboard_Componente: titulo = "-",
    Valor_Meta = {},
    Texto_Info = "-",
    Texto_BizAI = "",
    ESG_Info = "-",
    Codigo_Transacao_Link = "",
    Titulo_Transacao_Link = "",
    Conteudo_Dados = ""
  } = safeItem;

  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const togglePopup = () => setIsPopupOpen(!isPopupOpen);
  const slugId = Sigla.trim().replace(/\s+/g, "-");

  let linhasData = {};
  let quebraLinha = false;

  try {
    const parsed = JSON.parse(Conteudo_Dados);
    linhasData = parsed.Linhas || {};
    quebraLinha = parsed.Quebra_Linha === true || parsed.Quebra_Linha === "true";
  } catch (err) {
    console.error("Erro ao parsear Conteudo_Dados:", err);
  }

  const linhas = Object.entries(linhasData);

  return (
    <>
      <Card className="w-100 h-100 multLinhas">
        <CardBody className="w-100 h-100 d-flex flex-column cardbody-dash">
          <CardHeader
            titulo={titulo}
            Texto_Info={Texto_Info}
            ESG_Info={ESG_Info}
            togglePopup={togglePopup}
            slugId={slugId}
            textoIA={Texto_BizAI}
            Codigo_Transacao_Link={Codigo_Transacao_Link}
            Titulo_Transacao_Link={Titulo_Transacao_Link}
          />

          <Meta Valor_Meta={Valor_Meta} />

          {quebraLinha ? (
            // Container cresce para vertical centrar
            <div className="mt-1 flex-grow-1 d-flex align-items-center justify-content-center">
              <div className="dados-lista">
                <ul className="list-dados d-flex flex-column align-items-center justify-content-center">
                  {linhas.length > 0 ? (
                    linhas.map(([chave, valor], index) => (
                      <React.Fragment key={index}>
                        <li className="font-size-14 text-black text-center">{chave}</li>
                        <li className="font-size-24 font-w-600 text-black text-center mb-3">{valor}</li>
                      </React.Fragment>
                    ))
                  ) : (
                    <li className="text-center">Sem dados</li>
                  )}
                </ul>
              </div>
            </div>
          ) : (
            
     
          
             
            <div className={`mt-1 d-flex ${linhas.length > 0 ? 'align-items-end justify-content-end' : 'flex-grow-1 align-items-center justify-content-center'}`}>
              <div className="dados-lista">
                <ul className="list-dados">
                  {linhas.length > 0 ? (
                    linhas.map(([chave, valor], index) => (
                      <li key={index}>
                        <span className="font-size-14 text-black">{chave}</span>
                        <span className="font-size-18 font-w-600 text-black">{valor}</span>
                      </li>
                    ))
                  ) : (
                    
                    <li className="text-center">
                      <div className="font-size-14 w-100 h-100 d-flex vertical-center align-items-center justify-content-center text-muted">
                        Sem dados para exibir
                       </div> 
                    </li>
                  )}
                </ul>
              </div>
            </div>
          )}
        </CardBody>
      </Card>

      <SuperInsightsModal
        isOpen={isPopupOpen}
        toggle={togglePopup}
        textoIA={Texto_BizAI}
      />
    </>
  );
};

export default TrendChartMulti;
